import { Term, Instalment } from 'src/shared/types/booking-types';

export const getTermByInstalmentId = (
    terms: Term[] | undefined,
    instalmentId: string | undefined
): Term | undefined => {
    if (!terms || !instalmentId) return undefined;

    return terms.find((term) =>
        term.instalments?.some(
            (instalment: Instalment) => String(instalment.id) === String(instalmentId)
        )
    );
};
